import { useNavigate } from "react-router-dom";

const MedicalAssessment = () =>{
    const navigate = useNavigate();

    return (

       
  <div className="col-xl-6" key={"medical_id"}>
                    <div className="parent-assesment-cards">
                      <div className="dashboard-title mb-3">
                        <div className="font-md fw-semibold">Medical Assessment</div>
                      </div>
                      <p>Evaluation of your current health status, body composition, abdominal obesity, insulin sensitivity and risk of Pre-diabetes and other metabolic disorders</p>
                        <button
                          onClick={() => {
                            navigate(`/user/assessments/medical-assessment`);
                        }}
                          className="btn-assessment font-xsm btns btn-animation-blue mt-xxl-4 mt-2 home-button mend-auto"
                        >
                          View <i className="fa-solid fa-right-long icon"></i>
                        </button>
                    </div>
                  </div>
                  

      );
}

export default MedicalAssessment;